import { render, staticRenderFns } from "./InstallMeterRecord.vue?vue&type=template&id=671dcc25&"
import script from "./InstallMeterRecord.vue?vue&type=script&lang=js&"
export * from "./InstallMeterRecord.vue?vue&type=script&lang=js&"
import style0 from "./InstallMeterRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports